import { acceptHMRUpdate, defineStore } from 'pinia'

import api from '@/lib/api'

export const useCurrentInventoryStore = defineStore('current-inventory', {
  state: () => ({
    currentInventoryData: [],
    pagination: {},
  }),

  actions: {
    async getCurrentInventory(filters) {
      const response = await api.inventoryTracking.getCurrentInventory(filters)
      this.currentInventoryData = response.data.currentInventory
      return response.data.pagination
    },

    async editCurrentInventory(currentInventoryData) {
      return api.inventoryTracking.editCurrentInventory(currentInventoryData)
    },

    async downloadCurrentInventory(searchTerm) {
      const response = await api.inventoryTracking.downloadCurrentInventory(searchTerm)
      return response
    },

    resetState() {
      this.$reset()
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCurrentInventoryStore, import.meta.hot))
}
